import * as React from 'react';
import { Container } from 'reactstrap';
import { Route, Switch } from 'react-router';
import NavMenu from './NavMenu';
import SubLayout from './SubLayout';

import Home from './Home';
import SignInComponent from './auth/SignInComponent';
import UserEmployee from './useremployee/UserEmployee';
import PositionEmployee from './positionemployee/PositionEmployee';
import AddPositionEmployee from './positionemployee/AddPositionEmployee';
import PositionGroup from './positiongroup/PositionGroup';
import AddPositionGroup from './positiongroup/AddPositionGroup';
import Workflow from './workflow/Workflow';
import AddWorkflow from './workflow/AddWorkflow';
import SignOut from './auth/SignOutComponent';
import ConditionMaster from './condition/ConditionMaster';
import TypeMaster from './type/TypeMaster';
// import WorkflowInbox from './workflow/WorkflowInbox'
import WorkflowDashboard from './workflow/WorkflowDashboard';
import AddConfigMaster from './config/AddConfigMaster';
import WorkflowDashboardInformationDetail from './workflow/WorkflowDashboardInformationDetail';
import WorkflowDashboardInformationDetailFn from './workflow/WorkflowDashboardInformationDetailFn';
import CreateWorkflow from './workflow/CreateWorkflow';
import WorkflowInboxInformation from './workflow/WorkflowInboxInformation';
import WorkflowInformation from './workflow/WorkflowInformation';
import Ingress from './ingress/Ingress';
import WorkflowReportAdmin from './workflow/WorkflowReportAdmin';
import WorkflowLog from './log/Log';
import EmailLog from './log/EmailLog';
import CreateWorkflowWithWftype from './workflow/CreateWorkflowWithWftype';
import MasterEmployee from './config/MasterEmployee';
import WorkflowInboxOverview from './workflow/WorkflowInboxOverview';
import WorkflowDashboardOverview from './workflow/WorkflowDashboardOverview';
import { PrivateRoute } from './PrivateRoute';
import { AuthRedirectRoute } from './AuthRedirectRoute';
import WorkflowInboxMobile from './workflow/WorkflowInboxMobile';
import WorkflowConditionConfigReport from './workflowreport/WorkflowConditionConfigurationReport';
import WorkflowAssignmentRoutingReport from './workflowreport/WorkflowAssignmentRoutingReport';
import SimulateWorkflow from './simulateworkflow/SimulateWorkflow';
import EsignCallback from './esigncallback/esigncallback';
import WorkflowOnlineForm from './workflow/WorkflowOnlineForm';
import OnlineFormInformation from './workflow/OnlineFormInformation';
import LineConnectView from '../presentations/views/LineConnect/LineConnect.view';
import WorkflowOnlineFromView from 'presentations/views/WorkflowOnlineForm/WorkflowOnlineForm.view';
import WorkflowConfigAdmin from 'presentations/views/WorkflowConfigAdmin/WorkflowConfigAdmin.view';
import RoleMasterEmployee from 'presentations/views/RoleMasterEmployee/RoleMasterEmployee.view';
import LogBuffer from 'presentations/views/LogBuffer/WorkflowLogBuffer.view';
import CallbackLogStart from 'presentations/views/CallbackStart/CallbackStart.view';
import CallbackLog from 'presentations/views/CallbackLog/CallbackLog.view';
import BufferStat from 'presentations/views/BufferStat/BufferStat.view';
import AssignmentRoutingConfig from 'presentations/views/AssignmentRouting/AssignmentRoutingConfig.view';
import AuthenticationHistoryLogs from './history/AuthenticationHistoryLogs';
import ExportEmployeeRoles from './workflow/ExportEmployeeRoles';
import EmailConfig from '../presentations/views/EmailConfig/EmailConfig.view';
import WorkflowUsageRateView from '../presentations/views/WorkflowUsageRate/WorkflowUsageRate.view';
import WorkflowPerformanceView from 'presentations/views/WorflowPerformance/WorkflowPerformance.view';

import WorkflowInbox from 'presentations/views/WorkflowInbox/WorkflowInbox';
import { NotFound } from '../presentations/views/NotFound/NotFound';
import { WorkflowTypeMasterConfig } from 'presentations/views/WorkflowTypeMasterConfig/WorkflowTypeMasterConfig';
import { WorkflowMenuMasterConfig } from '../presentations/views/WorkflowMenuMasterConfig/WorkflowMenuMasterConfig';
import { WorkflowRoleMasterConfig } from 'presentations/views/WorkflowRoleMasterConfig/WorkflowRoleMasterConfig';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { RouteGroup, routeGroups, RouteInfo } from './Routes';
import { extractAccessToken } from '../helpers/decodeLocalStorage';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { AdminDetail } from '../models/admin/MasterAdmin';
import { ResponseList } from '../models/Response';
import Swal from 'sweetalert2';
import WorkflowInboxInformationViewerFn from 'presentations/views/WorkflowInboxInformationViewer/WorkflowInboxInformationViewerFn.view';
import WorkflowInboxInformationDetailFn from './workflow/WorkflowInboxInformationDetailFn';
import LineConfig from 'presentations/views/LineConfig/LineConfig.view';
import RecuringJobLogView from 'presentations/views/RecuringJobLog/RecuringJobLog.view';

export default function Layout() {
    const location = useLocation();
    const history = useHistory();

    // const routeInfoMap = useMemo(
    //     () =>
    //         new Map<string, RouteInfo>(
    //             routeGroups
    //                 // @ts-ignore
    //                 .flatMap((routeGroup: RouteGroup) => routeGroup.routes)
    //                 .map((route: RouteInfo) => [route.pathname, route])
    //         ),
    //     []
    // );

    // const citizenId = useMemo(() => {
    //     const payload = extractAccessToken();
    //     return payload.citizen_id ?? payload.username;
    // }, []);
    //
    // const { data: adminDetails } = useQuery({
    //     enabled: !!citizenId,
    //     queryKey: ['admin-details', citizenId],
    //     queryFn: ({ signal }) =>
    //         axios.get<ResponseList<AdminDetail>>('/v2/configuration/admin', {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem(
    //                     'WF_APPLICATION'
    //                 )}`
    //             },
    //             params: {
    //                 citizen_id: citizenId
    //             }
    //         }),
    //     select: (response: AxiosResponse<ResponseList<AdminDetail>>) =>
    //         response.data.result_list,
    //     retry: 1
    // });
    // const allowedMenuIds = useMemo(
    //     () =>
    //         adminDetails
    //             ? new Set(adminDetails.map(adminDetail => adminDetail.menu_id))
    //             : undefined,
    //     [adminDetails]
    // );

    // useEffect(() => {
    //     if (!allowedMenuIds || allowedMenuIds.size === 0) {
    //         return;
    //     }
    //
    //     const pathname = location.pathname;
    //     const routeInfo = routeInfoMap.get(pathname);
    //     if (!routeInfo || !routeInfo.menuId) {
    //         return;
    //     }
    //
    //     const isAllowed = allowedMenuIds.has(routeInfo.menuId);
    //     if (!isAllowed) {
    //         const _ = Swal.fire({
    //             title: 'ไม่ได้รับอนุญาตในการเข้าถึงเมนูนี้',
    //             icon: 'error',
    //         })
    //         history.goBack();
    //     }
    // }, [location, routeInfoMap, allowedMenuIds]);

    return (
        <React.Fragment>
            <Switch>
                <Route
                    path="/auth/signin"
                    component={SignInComponent}
                />
                <Route
                    path="/workflow-report"
                    component={WorkflowDashboard}
                />
                <Route
                    path="/workflow-create"
                    component={CreateWorkflow}
                />
                <Route
                    path="/ingress-workflow-inbox"
                    component={Ingress}
                />
                <Route
                    path="/callback/e-sign"
                    component={EsignCallback}
                />
                <Route
                    path="/workflow-online-form"
                    component={WorkflowOnlineFromView}
                />
                <Route
                    path="/online-form-information"
                    component={OnlineFormInformation}
                />
                <Route
                    path="/line-connect"
                    component={LineConnectView}
                />
                <Route
                    path="/workflow-report-detail"
                    component={WorkflowDashboardInformationDetail}
                />
                <Route
                    path="/workflow-report-detail-new"
                    component={WorkflowDashboardInformationDetailFn}
                />
                <Route
                    path="/workflow-inbox-detail-new"
                    component={WorkflowInboxInformationDetailFn}
                />
                <SubLayout>
                    <Route
                        path="/workflowinbox-mobile"
                        component={WorkflowInboxMobile}
                    />
                    <Route
                        path="/workflow-inbox-overview"
                        component={WorkflowInboxOverview}
                    />
                    <Route
                        path="/workflow-inbox-detail-test"
                        component={WorkflowInboxInformationViewerFn}
                    />
                    <Route
                        path="/workflow-inbox-detail"
                        component={WorkflowInboxInformation}
                    />
                    <Route
                        path="/workflow-report-overview"
                        component={WorkflowDashboardOverview}
                    />
                    <Route
                        path="*"
                        component={NotFound}
                    />
                    <PrivateRoute
                        exact
                        path="/"
                        component={Home}
                    />
                    <PrivateRoute
                        path="/roleemployee"
                        component={PositionEmployee}
                    />
                    <PrivateRoute
                        path="/addpositionemployee"
                        component={AddPositionEmployee}
                    />
                    <PrivateRoute
                        path="/authoritygroup"
                        component={PositionGroup}
                    />
                    <PrivateRoute
                        path="/addauthoritygroup"
                        component={AddPositionGroup}
                    />
                    <PrivateRoute
                        path="/workflow"
                        component={Workflow}
                    />
                    <PrivateRoute
                        path="/addworkflow"
                        component={AddWorkflow}
                    />
                    <PrivateRoute
                        path="/logout"
                        component={SignOut}
                    />
                    <PrivateRoute
                        path="/conditionmaster"
                        component={ConditionMaster}
                    />
                    <PrivateRoute
                        path="/workflowreport"
                        component={WorkflowReportAdmin}
                    />
                    <PrivateRoute
                        path="/workflowlog"
                        component={WorkflowLog}
                    />
                    <PrivateRoute
                        path="/workflow-email-log"
                        component={EmailLog}
                    />
                    <AuthRedirectRoute
                        path="/workflowinbox"
                        component={WorkflowInbox}
                    />
                    <PrivateRoute
                        path="/workflowdashboard"
                        component={WorkflowDashboard}
                    />
                    <PrivateRoute
                        path="/callbackconfigmaster"
                        component={AddConfigMaster}
                    />
                    <PrivateRoute
                        path="/createworkflow"
                        component={CreateWorkflow}
                    />
                    <PrivateRoute
                        path="/createworkflowwithwftype"
                        component={CreateWorkflowWithWftype}
                    />
                    <PrivateRoute
                        path="/masterEmployee"
                        component={MasterEmployee}
                    />
                    <PrivateRoute
                        path="/workflowinboxadmin"
                        component={WorkflowInbox}
                    />
                    <PrivateRoute
                        path="/workflowinboxadminsummary"
                        component={WorkflowReportAdmin}
                    />
                    <PrivateRoute
                        path="/workflowconditionconfigurationreport"
                        component={WorkflowConditionConfigReport}
                    />
                    <PrivateRoute
                        path="/workflowassignmentroutingreport"
                        component={WorkflowAssignmentRoutingReport}
                    />
                    <PrivateRoute
                        path="/simulateworkflow"
                        component={SimulateWorkflow}
                    />
                    <PrivateRoute
                        path="/createUserAdmin"
                        component={WorkflowConfigAdmin}
                    />
                    <PrivateRoute
                        path="/rolemasteremployee"
                        component={RoleMasterEmployee}
                    />
                    <PrivateRoute
                        path="/workflowlogbuffer"
                        component={LogBuffer}
                    />
                    <PrivateRoute
                        path="/callbacklogstart"
                        component={CallbackLogStart}
                    />
                    <PrivateRoute
                        path="/callbacklog"
                        component={CallbackLog}
                    />
                    <PrivateRoute
                        path="/bufferstat"
                        component={BufferStat}
                    />
                    <PrivateRoute
                        path="/assignmentroutingconfig"
                        component={AssignmentRoutingConfig}
                    />
                    <PrivateRoute
                        path="/auth-history"
                        component={AuthenticationHistoryLogs}
                    />
                    <PrivateRoute
                        path="/export-employee-roles"
                        component={ExportEmployeeRoles}
                    />
                    <PrivateRoute
                        path="/email-config"
                        component={EmailConfig}
                    />
                    <PrivateRoute
                        path="/workflow-usage-rate"
                        component={WorkflowUsageRateView}
                    />
                    <PrivateRoute
                        path="/workflow-performance"
                        component={WorkflowPerformanceView}
                    />
                    <PrivateRoute
                        path="/workflow-type-master-config"
                        component={WorkflowTypeMasterConfig}
                    />
                    <PrivateRoute
                        path="/workflow-menu-master-config"
                        component={WorkflowMenuMasterConfig}
                    />
                    <PrivateRoute
                        path="/workflow-role-master-config"
                        component={WorkflowRoleMasterConfig}
                    />
                    <PrivateRoute
                        path="/line-config"
                        component={LineConfig}
                    />
                    <PrivateRoute
                        path="/recuring-job-log"
                        component={RecuringJobLogView}
                    />
                </SubLayout>
            </Switch>
        </React.Fragment>
    );
}
